<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>{{'header.tehasil.title' | translate }}
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.tehasil.table.AddNewTehasilRecord' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b> {{'header.tehasil.title' | translate }}</b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.tehasil.table.UpdateTehasilRecord' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>{{'header.tehasil.title' | translate }} </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.tehasil.table.DeleteTehasilRecord' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="TehasilForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row mt-3 clearfix">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.tehasil.table.districtName' | translate}}</mat-label>

                                                <mat-select  #select343 [disabled]="ureadonly || dreadonly"
                                                    placeholder="DsCode" class="colorblack"
                                                    formControlName="DsCode">
                                                    <mat-select-filter *ngIf="select343.focused" required
                                                        [placeholder]="'Filter'" [displayMember]="'DsName'"
                                                        [array]="DistrictList"
                                                        (filteredReturn)="filteredListDistrict =$event"></mat-select-filter>
                                                    <mat-option onkeydown="return (event.keyCode!=13);"
                                                        *ngFor="let item of filteredListDistrict"
                                                        [value]="item.DsCode">
                                                        {{item.DsName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TehasilForm.controls['DsCode'].touched && TehasilForm.controls['DsCode'].errors?.required">
                                                    {{'header.tehasil.table.Mandatory' | translate}} </mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.tehasil.table.tehasilCode' | translate}}
                                                </mat-label>
                                                <input appUppercase required onkeydown="return (event.keyCode!=13);"
                                                [readonly]="ureadonly || dreadonly"  class="color"
                                                    type="text" placeholder="Tehasil Code" formControlName="TsCode"
                                                    matInput  maxlength="5">
                                                <mat-error class="margin_tp"
                                                    *ngIf="TehasilForm.controls['TsCode'].touched && TehasilForm.controls['TsCode'].errors?.required">
                                                    {{'header.tehasil.table.Mandatory' | translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TehasilForm.controls['TsCode'].touched && TehasilForm.controls['TsCode'].errors?.pattern">
                                                    {{'header.tehasil.table.Invalid' | translate}} </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.tehasil.table.tehasilName' | translate}}
                                                </mat-label>
                                                <input appCamelcase  [readonly]="dreadonly" required onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    placeholder="Tehasil Name"  maxlength="40"
                                                    formControlName="TsName" matInput >
                                                <mat-error class="margin_tp"
                                                    *ngIf="TehasilForm.controls['TsName'].touched && TehasilForm.controls['TsName'].errors?.required">
                                                    {{'header.tehasil.table.Mandatory' | translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TehasilForm.controls['TsName'].touched && TehasilForm.controls['TsName'].errors?.pattern">
                                                    {{'header.tehasil.table.Invalid' | translate}} </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-sm-12">
                                        <button type="button" *ngIf="submitButton && tehasilCreate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                        (click)="submit()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/save.gif"
                                                style="margin-right: 5px;">
                                            {{'header.tehasil.table.Save' | translate}}
                                        </span>
                                    </button>
                                    <button type="button" *ngIf="editButton && tehasilUpdate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="update()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="29%" src="../../assets/img/edit1.gif"
                                            style="margin-right: 5px;">
                                        {{'header.tehasil.table.Update' | translate}}
                                    </span>
                                </button>
                                <button type="button" *ngIf="deleteButton && tehasilDelete" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif"
                                        style="margin-right: 5px;">
                                    {{'header.tehasil.table.Delete' | translate}}
                                </span>
                            </button>
                                        <button type="button" [mat-dialog-close]="true"
                                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="23%" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                {{'header.tehasil.table.Back' | translate}}
                                            </span>
                                        </button>

                                    </div>
                                    

                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> 